const state = {
  // 初始化屏幕宽度
  screenWidth: document.documentElement.clientWidth || window.innerWidth
};

const mutations = {
  SET_SCREEN_WIDTH(state, width) {
    state.screenWidth = width;
  }
};

const getters = {
  getScreenWidth: state => state.screenWidth,
  // 方便判断是否为移动端
  isMobile: state => state.screenWidth < 768
};

export default {
  namespaced: true,
  state,
  mutations,
  getters
};